"use client"
import React from 'react'
import { Box, Button, Typography, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { deleteInitiative } from './initiative.service';
import { resultMessage } from '../../../../service/apiResult';
import { Icon } from "@iconify/react";
import {
    confirmationDialogSx,
    confirmationIconSx,
    confirmationPrimaryButtonSx,
    confirmationSecondaryButtonSx,
    confirmationTextSx,
    confirmationTitleSx,
} from '../../../styles/dialogStyles';

export default function InitiativeDeleteModal(props) {

    const { onClose, getInitiativeData, selectedId, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose } = props;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await deleteInitiative(selectedId);
        if (res.success) {
            setResponseMsg(resultMessage(res, 'Initiative deleted successfully'));
            setLoading(false);
            setAlert('true');
            setOpenAlert(true);
            setTimeout(() => {
                alertClose();
                getInitiativeData();
                onClose();
            }, ALERT_DURATION);
        } else {
            // Show what the server actually said, not a guess: these refusals name the
            // obstacle, and that is the whole value of them.
            setResponseMsg(resultMessage(res));
            setAlert('false');
            setOpenAlert(true);
            setLoading(false);
            // Close so the message behind the modal is readable. Nothing changed, so
            // there is nothing to refresh.
            onClose();
        }
    };

    return (
        <Box sx={confirmationDialogSx}>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Button onClick={onClose} sx={{ minWidth: 'auto', p: 0.5, color: '#6B7280', borderRadius: '999px' }}>
                    <CloseIcon data-testid="CancelIcon" />
                </Button>
            </Stack>
            <form onSubmit={onSubmit}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box sx={confirmationIconSx}>
                        <Icon icon="proicons:alert-triangle" width="36" height="36" color="#C40000" />
                    </Box>
                    <Typography sx={confirmationTitleSx}>Warning!</Typography>
                    <Typography sx={confirmationTextSx}>Do you want to continue?</Typography>
                    <Typography sx={confirmationTextSx}>This action cannot be undone.</Typography>
                    <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ pt: 1 }}>
                        <Button variant="contained" type="submit" sx={confirmationPrimaryButtonSx}>Yes</Button>
                        <Button onClick={onClose} sx={confirmationSecondaryButtonSx}>No</Button>
                    </Stack>
                </Stack>
            </form>

        </Box>
    )
}
